import React from 'react'
import api from '../../../services/api'
import { Spin, Tag } from 'antd'
import moment from 'moment'


export default class NotaFiscalTableRow extends React.Component {

    state = {}

    componentDidMount() {
        this.getParcela()
    }

    getParcela = async () => {
        let aux = this.props.nf[' vencimento ']
        console.log(aux)
        let data_vencimento = null
        if (typeof aux === 'number') {
            data_vencimento = moment(
                (aux - (25567 + 1)) * 86400 * 1000
            ).format("YYYY-MM-DD");
        } else {
            aux = aux.split('/')
            data_vencimento = aux[2] + '-' + aux[1] + '-' + aux[0]
        }

        let params = {
            status_parcela: '1',
            acordo__pasta__pasta: this.props.nf.PASTA,
            valor_parcela: this.props.nf[' valor_parcela '],
            data_vencimento: data_vencimento
        }
        if (this.props.judicial) {
            console.info('vai recalcular valor')
            params['valor_parcela'] = params['valor_parcela'] * 100 / 15;
        } else {
            params['valor_parcela'] = this.props.nf[' VLR. PARCELA ']
        }
        console.log('props', this.props)
        console.log('params', params)
        const res = await api.get('/parcela/', { params: params })
        if (res.data.results != null) {
            if (res.data.results.length == 1) {
                this.setState({ 'parcela': res.data.results[0], cadastrado: false })
                this.cadastra_nf()
            } else {
                this.setState({ 'erro': 'Mais de uma parcela encontrada' })
            }
        } else {
            this.setState({ 'erro': 'Parcela não encontrada' })
        }
    }

    cadastra_nf = () => {

        let res = api.post('/notafiscal/', {
            parcela: this.state.parcela.id,
            numero_nf: this.props.nf['NF.']
        })
        res.then(result => {
            //console.log(result)
            if (result.status == 201) {
                this.setState(
                    {
                        ...this.state,
                        status: "Nota fiscal foi cadastrada com sucesso!",
                        color_tag: '#87d068'
                    })
            }
        }).catch(error => {
            //console.log(error.response)
            if (error.response.status == 400) {
                this.setState(
                    {
                        ...this.state,
                        status: "Nota fiscal já está cadastrada",
                        color_tag: '#f50'
                    }
                )
            }
        })
    }

    render() {

        if ('parcela' in this.state) {
            return (
                <React.Fragment>
                    <tr>
                        <td>{this.state.parcela.pasta}</td>
                        <td>{this.props.nf['NF.']}</td>
                        <td>{moment(this.state.parcela.data_vencimento).format('DD/MM/YYYY')}</td>
                        <td>{'R$ ' + this.state.parcela.valor_parcela.toFixed(2).toLocaleString()}</td>
                        <td>{'status' in this.state ? (<Tag color={this.state.color_tag}>{this.state.status}</Tag>) : <Spin></Spin>}</td>
                    </tr>
                </React.Fragment>
            )
        } else if ('erro' in this.state) {
            return (
                <React.Fragment>
                    <tr>
                        <td>{this.props.nf['PASTA']}</td>
                        <td>{this.props.nf['NF.']}</td>
                        <td></td>
                        <td></td>
                        <td><Tag color="#f50">{this.state.erro}</Tag></td>
                    </tr>
                </React.Fragment>
            )
        } else {
            return (
                <React.Fragment>
                    <tr>
                        <td><Spin></Spin></td>
                    </tr>
                </React.Fragment>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/NotaFiscal/components/table_row.js